// Helper for calling /api/admin with the stored admin token.

const TOKEN_KEY = 'elx_admin_token';

export function getAdminToken() {
  if (typeof sessionStorage === 'undefined') return null;
  return sessionStorage.getItem(TOKEN_KEY);
}

export function setAdminToken(token) {
  sessionStorage.setItem(TOKEN_KEY, token);
}

export function clearAdminToken() {
  sessionStorage.removeItem(TOKEN_KEY);
}

export async function adminCall(op, payload = {}) {
  const token = getAdminToken();
  const res = await fetch('/api/admin', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ op, ...payload }),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `Admin call failed (${res.status})`);
  }
  return res.json();
}
